<div class="fulfillmentLanding seed-return-wrapper subscriptionManagement">
  <div class="SubscriptionManagement">
    <div class="row">
      <div class="col-md-8 col-lg-8 margin-l0 TopSec">
        <h3>
          Subscription Management
        </h3>
        <p class="smalltext margin-b0">
          Below are your subscriptions to the various email notification features in Evolve.
        </p>
      </div>
      <div class="subscribe-sec col-md-4 col-lg-4">
        <div class="row justify-content-end padding-r5">
          <a href="Javascript:void(0);" *ngIf="isCPPPriceListAccess" mat-menu-item (click)="redirectToCPPProductsOrPrice()" class="text-uppercase text-decoration-underline">Manage pricing Subscription</a>
        </div>
      </div>
    </div>
    <div class="xs-pr-15 text-right">
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isShowFilterButton]="true" [isSearchButtonOutside]="false" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
    </div>

    <div class="row">
      <div class="col-8"></div>
      <div class="showChangesSection col-4 padding-r0 padding-t2" [ngStyle]="{'pointer-events':'auto'}">
        <div class="toggleColor">
          <span class="padding-r10" style="color: #004E7A;">GROUP BY: <b style="color: #004E7A;"> {{isGroupByUserId ? "USER ID" : "ACCOUNTS"}}</b> </span>
          <label class="switch">
            <input type="checkbox" (click)="toggleGroupBy()" [checked]="false">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="col-md-12 legend-outer">

        <mat-tab-group disableRipple [(selectedIndex)]="selectedTabIndex" [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">

          <mat-tab>
            <ng-template mat-tab-label>
              <div class="tab-head" id="transferFromTab">
                <h4>
                  My Subscriptions
                </h4>
              </div>
            </ng-template>
            <div class="col-md-12 padding-0">
              <app-my-subscriptions-component [userIdGridDS]="mySubscriptionUserIDGroupingData" [accountsGridDS]="mySubscriptionAccountGroupingData" (SubscribeOutput)="onSubscribeEmail($event)" (SetGlobalSubscriptionData)="onSetGlobalSubscriptionData($event)" (GlobalSubscriptionClick)="onGlobalSubscriptionClick($event)" [groupBy]="isGroupByUserId ? 'userId' : 'accounts' " [selectedTab]="selectedTabIndex == 0 ? 'mySubscription' : 'manageSubscrition' "></app-my-subscriptions-component>
            </div>
          </mat-tab>

          <mat-tab *ngIf="isShowManageSub">
            <ng-template mat-tab-label>
              <div class="tab-head" id="transferToTab">
                <h4>
                  Manage Subscriptions
                </h4>
              </div>
            </ng-template>

            <div class="col-md-12 padding-0">
              <app-manage-subscriptions-component [userIdGridDS]="manageSubscriptionUserIdGroupingData" [accountsGridDS]="manageSubscriptionAccountGroupingData" (Subscribe)="onSubscribeEmail($event)" (SetGlobalSubscriptionData)="onSetGlobalSubscriptionData($event)" (GlobalSubscriptionClick)="onGlobalSubscriptionClick($event)" [groupBy]="isGroupByUserId ? 'userId' : 'accounts' " [readOnly]="readOnlyAccess" [selectedTab]="selectedTabIndex == 0 ? 'mySubscription' : 'manageSubscrition' "></app-manage-subscriptions-component>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
  <div class="row add-order-sec margin-l0 margin-r0">
    <div class="col-md-1"></div>
    <div class="col-md-2 padding-r0 margin-l10">
      <!--<button mat-raised-button class="btns wide70" color="primary" [disabled]="dataListForSave.length==0" (click)="onSaveClick()">Save</button>-->
    </div>
    <div class="col-md-2 padding-l0">
      <!--<button mat-raised-button class="btns wide70" color="primary" [disabled]="dataListForSave.length==0" (click)="cancelSubscriptions()">Cancel</button>-->
    </div>
    <div class="col-md-2"></div>
    <div class="col-md-4 text-right">
      <button mat-raised-button (click)="export()" class="btns w160" color="primary" [disabled]="isExportDisabled">Export</button>
      <span class="count">Accounts Selected <span class="countNum">{{selectedUsers}} </span></span>
    </div>
  </div>
</div>
